import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";

export const FieldOccurencesItemSchema = z
  .object({
    typeOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    title: z.string().min(1, { message: REQUIRED_FIELD }),
    levelOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),

    provinceOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),

    countyOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
    description: z.string().min(1, { message: REQUIRED_FIELD }),
  })
  .superRefine((data, ctx) => {
    if (data?.levelOption?.id === 2 && !data?.countyOption) {
      ctx.addIssue({
        path: ["countyOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
  });
